export default __webpack_public_path__ + "assets/09ab0626-bb45-4650-acc8-0182d693df02.woff2";